import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

const AnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
  const apiKey = import.meta.env.VITE_POSTHOG_API_KEY
  const host = import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com'
  const analyticsEnabled = import.meta.env.VITE_ENABLE_ANALYTICS === 'true'

  if (!analyticsEnabled || !apiKey) {
    return children
  }

  // Initialize PostHog if not already initialized
  if (!posthog.__loaded) {
    posthog.init(apiKey, {
      api_host: host,
      autocapture: true,
      enable_heatmaps: true,
      capture_pageview: true,
      capture_pageleave: true,
      disable_session_recording: !import.meta.env.PROD,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '*',
      },
      loaded: (ph) => {
        if (!import.meta.env.PROD) {
          ph.debug()
        }
      },
    })
  }

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}

export { AnalyticsProvider }
